"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiBase = exports.HostKey = exports.ServiceName = void 0;
const loader_1 = require("./loader");
const host_1 = require("./host");
var host_2 = require("./host");
Object.defineProperty(exports, "ServiceName", { enumerable: true, get: function () { return host_2.ServiceName; } });
Object.defineProperty(exports, "HostKey", { enumerable: true, get: function () { return host_2.HostKey; } });
class ApiBase {
    constructor(host) {
        this.host = '';
        this.hostKey = '';
        this.client = null;
        this.service = () => {
            const host = this.host || dog.config.getHost(this.hostKey);
            if (!this.client) {
                throw 'client is not defined';
            }
            if (!host) {
                throw 'host is not defined';
            }
            const service = new this.client(host);
            this.EnableGrpcDebugTools(service);
            return service;
        };
        this.EnableGrpcDebugTools = (service) => {
            if (localStorage.getItem('dogdebug') === 'true') {
                // @ts-ignore
                const enableDevTools = window.__GRPCWEB_DEVTOOLS__ || (() => { });
                enableDevTools([service]);
            }
        };
        if (host) {
            this.host = host;
        }
    }
}
exports.ApiBase = ApiBase;
/**
 * setProductServicesDomain
 *
 * @param  {ServiceName} serviceName
 * @param  {string} domain
 */
const setProductServicesDomain = (serviceName, domain) => {
    const services = host_1.groupServices[serviceName] || [];
    if (services.length > 0) {
        services.map(name => {
            if (getHost(name) === '') {
                setHost(name, domain);
            }
        });
    }
};
/**
 * setHost
 *
 * @param  {string} host
 * @param  {string} domain
 */
const setHost = (host, domain) => {
    let hosts = dog.config.hosts;
    if (!hosts) {
        hosts = new Map();
    }
    hosts.set(host, domain);
    dog.config.hosts = hosts;
};
/**
 * getHost
 *
 * @param  {string} host
 * @returns string
 */
const getHost = (host) => {
    const hosts = dog.config.hosts;
    let domain = "";
    if (hosts) {
        domain = hosts.get(host) || "";
    }
    return domain;
};
/**
 * debug
 *
 * @returns void
 */
const debug = () => {
    localStorage.setItem("dogdebug", "true");
};
var getGlobal = function () {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof global !== 'undefined') {
        return global;
    }
    throw new Error('unable to locate global object');
};
var globals = getGlobal();
if (!globals.dog) {
    // @ts-ignore 強制初始化只有config
    globals.dog = {
        loader: loader_1.default,
        config: {
            hosts: new Map(),
            setHost,
            setProductServicesDomain,
            getHost,
            debug,
        }
    };
}
exports.default = dog;
